export type ManageTripsObservabilityData = {
  app: "ManageTripsNext";
  mt_language: "en" | "es" | "fr" | "unknown";
  mt_pathname: string;
  mt_render_mode: "preview" | "public";
  mt_route_group: "add-trip-email" | "itinerary" | "qualifier" | "unknown";
  mt_variant: "next";
};

const LANGUAGES = new Set(["en", "es", "fr"]);

function normalizePathname(pathname: string): string {
  if (!pathname || pathname === "/") {
    return "/";
  }

  let normalizedPathname = pathname;

  while (normalizedPathname.length > 1 && normalizedPathname.endsWith("/")) {
    normalizedPathname = normalizedPathname.slice(0, -1);
  }

  return normalizedPathname;
}

function getLanguage(segments: string[]) {
  const maybeLanguage = segments[0];

  if (typeof maybeLanguage === "string" && LANGUAGES.has(maybeLanguage)) {
    return {
      language: maybeLanguage as "en" | "es" | "fr",
      rest: segments.slice(1),
    };
  }

  return {
    language: "unknown" as const,
    rest: segments,
  };
}

function getRouteGroup(rest: string[]) {
  if (rest.length === 0) {
    return "qualifier" as const;
  }

  if (rest[0] === "-") {
    if (rest.length === 1) {
      return "qualifier" as const;
    }

    if (rest[1] === "itinerary") {
      return "itinerary" as const;
    }

    if (rest[1] === "add-trip-email") {
      return "add-trip-email" as const;
    }

    return "unknown" as const;
  }

  if (rest[0] === "manage-trips") {
    if (rest.length === 1) {
      return "qualifier" as const;
    }

    if (rest[1] === "itinerary") {
      return "itinerary" as const;
    }

    if (rest[1] === "add-trip-email") {
      return "add-trip-email" as const;
    }
  }

  return "unknown" as const;
}

export function getManageTripsObservabilityData(
  pathname: string,
): ManageTripsObservabilityData {
  const normalizedPathname = normalizePathname(pathname);
  const segments = normalizedPathname.toLowerCase().split("/").filter(Boolean);

  const isPreview = segments[0] === "preview";
  const pathSegments = isPreview ? segments.slice(1) : segments;

  const { language, rest } = getLanguage(pathSegments);

  return {
    app: "ManageTripsNext",
    mt_language: language,
    mt_pathname: normalizedPathname,
    mt_render_mode: isPreview ? "preview" : "public",
    mt_route_group: getRouteGroup(rest),
    mt_variant: "next",
  };
}
